<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PodrAddMain from "@/views/PurchaseManagement/PodrManage/TabChild/PodrAddMain";

export default {
  name: "PodrAdd",
  components: {
    childTab1: PodrAddMain,
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>